module.exports = __webpack_public_path__ + "static/MADE_Evolve_Sans_Medium_EVO-7e342ed0a71f5b9995ee05370a32a299.woff";